export default __webpack_public_path__ + "static/media/Group 11830.c14a48b3.svg";